import {faSpinner} from '@fortawesome/free-solid-svg-icons/faSpinner';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {FC} from 'react';
import {WithChildren} from '../helpers';
import {useI18n} from '../providers/I18nProvider';

interface Props {
	isLoading: boolean;
	showIcon?: boolean;
	showText?: boolean;
}

const InButtonLoader: FC<WithChildren & Props> = ({children, isLoading, showIcon = true, showText = true}) => {
	const {i18n} = useI18n();

	return (
		<>
			{!isLoading && (
				<span className='flex justify-center items-center md: text-[14px] md:mt-1 lg:mt-0'>{children}</span>
			)}
			{isLoading && (
				<span className='flex justify-center items-center'>
					{showText && (
						<span className={showIcon ? 'mr-2' : ''}>
							{i18n('COMMON.PLEASE_WAIT')}
							{showIcon ? '' : '...'}
						</span>
					)}
					{showIcon && <FontAwesomeIcon icon={faSpinner} spinPulse />}
				</span>
			)}
		</>
	);
};

export const InButtonLoading: FC<Omit<Props, 'isLoading'>> = (props) => {
	return (
		<InButtonLoader {...props} isLoading>
			Does not matter
		</InButtonLoader>
	);
};

export default InButtonLoader;
